import type { LucideIcon } from 'lucide-react';
import { Info, Lightbulb, TriangleAlert } from 'lucide-react';

import type { EvalFindingSeverity } from './types';

/**
 * Broker-facing grouping of findings. The model emits four severities; the
 * guidance panel shows three tiers, so LOW and INFO share the quietest one.
 */
export type FindingTier = 'PRIORITY' | 'IMPROVEMENT' | 'NOTE';

export const TIER_ORDER: FindingTier[] = ['PRIORITY', 'IMPROVEMENT', 'NOTE'];

export const TIER_BY_SEVERITY: Record<EvalFindingSeverity, FindingTier> = {
  HIGH: 'PRIORITY',
  MEDIUM: 'IMPROVEMENT',
  LOW: 'NOTE',
  INFO: 'NOTE',
};

export const TIER_LABEL: Record<FindingTier, string> = {
  PRIORITY: 'Priority',
  IMPROVEMENT: 'Improvement',
  NOTE: 'Note',
};

export const TIER_ICON: Record<FindingTier, LucideIcon> = {
  PRIORITY: TriangleAlert,
  IMPROVEMENT: Lightbulb,
  NOTE: Info,
};

interface TierClasses {
  /** Icon and group heading colour. */
  text: string;
  /** Group count pill. */
  pill: string;
  /** Recommendation callout background and body text. */
  callout: string;
  /** Recommendation callout heading. */
  calloutTitle: string;
}

export const tierClasses: Record<FindingTier, TierClasses> = {
  PRIORITY: {
    text: 'text-orange-600',
    pill: 'bg-orange-50 text-orange-700',
    callout: 'bg-orange-50 text-orange-950',
    calloutTitle: 'text-orange-700',
  },
  IMPROVEMENT: {
    text: 'text-violet-600',
    pill: 'bg-violet-50 text-violet-700',
    callout: 'bg-violet-50 text-violet-950',
    calloutTitle: 'text-violet-700',
  },
  NOTE: {
    text: 'text-gray-600',
    pill: 'bg-gray-100 text-gray-600',
    callout: 'bg-gray-100 text-gray-800',
    calloutTitle: 'text-gray-600',
  },
};
